module.exports = __webpack_public_path__ + "media/packs/images/flags/MZ-c290299be286ace2162e67adab1c31d0.svg";